import React, { useEffect, useState } from 'react';
import ConnectWalletHeader from './header/ConnectWalletHeader';
import Footer from './footer/Footer';
import { fetchAdminC2cDisputes, resolveAdminC2cDispute } from '../utils/c2cApi';
import './tables.css';
import './usdi_tables/USDIStats.css';

const getDisputeStatusColor = (status) => {
    const normalized = (status || '').toLowerCase();
    if (normalized === 'open') return '#E3CF6C';
    if (normalized === 'upheld') return '#E36C6C';
    if (normalized === 'rejected') return '#6CE3C4';
    return '#FFFFFFCC';
};

const C2CDisputes = () => {
    const [showPanel, setShowPanel] = useState(false);
    const [filter, setFilter] = useState('open');
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const load = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await fetchAdminC2cDisputes(filter);
            setRows(data);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, [filter]);

    const handleResolve = async (txsId, resolution) => {
        const notes = window.prompt('Optional admin notes:') || '';
        const label = resolution === 'upheld' ? 'block release (uphold dispute)' : 'reject dispute (release collateral)';
        if (!window.confirm(`Confirm: ${label} for txs_id ${txsId}?`)) return;
        try {
            await resolveAdminC2cDispute(txsId, resolution, notes);
            setMessage(`Order ${txsId}: dispute ${resolution}`);
            await load();
        } catch (e) {
            setMessage(e.message || 'Resolve failed');
        }
    };

    return (
        <div className="container">
            <div style={{ marginTop: '7px' }}>
                <ConnectWalletHeader isAdminHeader={true} showPanel={showPanel} setShowPanel={setShowPanel} />
            </div>
            <h3 className="pb-3">C2C Disputes</h3>
            <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <label style={{ color: '#FFFFFFCC', fontSize: '14px' }}>Filter by status:</label>
                <select
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className="status_dropdown"
                    style={{ padding: '6px 12px', minWidth: '180px' }}
                >
                    <option value="open">Open disputes</option>
                    <option value="all">All (disputes + conditional)</option>
                </select>
            </div>
            {message && <p style={{ color: '#6CE3C4' }}>{message}</p>}
            {loading && <p>Loading...</p>}
            {error && <p style={{ color: '#E36C6C' }}>Error: {error}</p>}
            {!loading && !error && (
                <div className="table-responsive noto mt-3">
                    <table className="table table-striped table-bordered mt-3">
                        <thead className="thead-dark">
                            <tr>
                                <th>Txs ID</th>
                                <th>Status</th>
                                <th>Dispute</th>
                                <th>Requestor</th>
                                <th>Node Operator</th>
                                <th>Conditional Deadline</th>
                                <th>Reason</th>
                                <th style={{ minWidth: 350 }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 ? (
                                <tr>
                                    <td colSpan={8}>No records</td>
                                </tr>
                            ) : (
                                rows.map((row) => (
                                    <tr key={row.cash_redeem_id || row.txs_id}>
                                        <td>{row.txs_id}</td>
                                        <td>{row.status}</td>
                                        <td style={{ color: getDisputeStatusColor(row.dispute_status) }}>
                                            {row.dispute_status || '—'}
                                        </td>
                                        <td style={{ maxWidth: 120, wordBreak: 'break-all' }}>{row.c2c_ex_wallet}</td>
                                        <td style={{ maxWidth: 120, wordBreak: 'break-all' }}>{row.node_operator_wallet}</td>
                                        <td>{row.conditional_release_deadline || '—'}</td>
                                        <td>{row.dispute_reason || '—'}</td>
                                        <td style={{ minWidth: 350 }}>
                                            {row.dispute_status === 'open' ? (
                                                <div className="c2c-dispute-actions">
                                                    <button
                                                        type="button"
                                                        className="c2c-dispute-action-btn c2c-dispute-action-btn--uphold"
                                                        onClick={() => handleResolve(row.txs_id, 'upheld')}
                                                    >
                                                        Block release
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="c2c-dispute-action-btn c2c-dispute-action-btn--reject"
                                                        onClick={() => handleResolve(row.txs_id, 'rejected')}
                                                    >
                                                        Reject dispute
                                                    </button>
                                                </div>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}
            <Footer />
        </div>
    );
};

export default C2CDisputes;
